<template>
    <v-dialog
        :value="isOpen"
        max-width="1600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Moje raporty
                </h1>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="detailedReportsListData"
                :mobile-breakpoint="0"
                name="reportsData"
            >
                <template #item.objectNumber="{item}">
                    {{ item.objectNumber }}
                    <v-tooltip 
                        v-if="item.productName"
                        :open-delay="tooltipDelay"
                        top
                    >
                        <template #activator="{on}">
                            <v-chip
                                class="pa-1 ml-1"
                                color="transparent"
                                v-on="on"
                            >
                                <v-icon color="green">
                                    mdi-comment-text-outline
                                </v-icon>
                            </v-chip>
                        </template>
                        <span>{{ `Nazwa produktu: ${item.productName}` }}</span>
                    </v-tooltip>
                </template>
                <template #item.machineSymbol="{item}">
                    {{ item.machineSymbol }}
                </template>
                <template #item.processName="{item}">
                    {{ item.processName }}
                </template>
                <template #item.plateNumber="{item}">
                    {{ item.plateNumberRead }}
                </template>
                <template #item.reportAmount="{item}">
                    {{ parseEmptyValue(item.reportAmount) }}
                </template>
                <template #item.machineStuffAmount="{item}">
                    {{ item.machineStuffAmount }}
                </template>
                <template #item.statusId="{item}">
                    <span
                        :class="{
                            'success--text': item.statusId === 99,
                            'error--text': item.statusId === 1
                        }"
                    >
                        {{ statusName(item.statusId) }}
                    </span>
                </template>
                <template #item.start="{item}">
                    {{ formatDate(item.makeReadyStart ? item.makeReadyStart : item.start) }}
                </template>
                <template #item.finish="{item}">
                    {{ formatDate(item.finish) }}
                </template>
                <template #item.duration="{item}">
                    {{ parseDuration(item.duration) }}
                </template>
                <template #item.actions="{item}">
                    <div class="d-inline-flex">
                        <v-tooltip :open-delay="tooltipDelay" top>
                            <template #activator="{on}">
                                <v-btn
                                    icon
                                    data-sentry-label="Szczegóły raportu"
                                    v-on="on"
                                    @click="openReport(item)"
                                >
                                    <v-icon color="blue">
                                        mdi-ballot
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Szczegóły raportu</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse.js'
import { appConfig } from '@/config.js'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'DetailedReportsListDialog',
    mixins: [
        dateFormatter,
        tooltipDelay,
        parse
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        detailedReportsListData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Numer',
                    value: 'objectNumber',
                    sortable: false
                },
                {
                    text: 'Maszyna',
                    value: 'machineSymbol',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Proces',
                    value: 'processName',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Montaż',
                    value: 'plateNumber',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Nakład wykonany',
                    value: 'reportAmount',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Ilość osób',
                    value: 'machineStuffAmount',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Status',
                    value: 'statusId',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Data rozpoczęcia',
                    value: 'start',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Data zakończenia',
                    value: 'finish',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Czas trwania',
                    value: 'duration',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        statusNames() {
            return this.$store.state.reports.reports.statusNames
        },
        productionProcesses() {
            return this.$store.state.configurations.productProductionProcesses.productionProcesses
        },
        workerTimeFilter() {
            return appConfig.reports.workerTimeFilter
        },
    },

    methods: {
        openReport(report) {
            this.$router.push({
                name: 'reportsReportingReport',
                params: {
                    id: report.id,
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        statusName(statusId) {
            return this.statusNames ? this.statusNames.find(item => item.id == statusId).name : statusId
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
